const WHAT_PRIME_BANNER = "what-prime";

const HEADER_PRIME_BENEFITS_ACTION = "header_prime_benefits";

export interface TrackingData {
  label: string;
  category: string;
  action: string;
}

export const whatPrimeBannerOnLoad = (
  isLoggedInUser: boolean | null,
  trackingCategory: string,
): TrackingData => ({
  label: `prime_header_benefit-banner_onload_${WHAT_PRIME_BANNER}_p:${isLoggedInUser}_pag:${trackingCategory}`,
  category: trackingCategory,
  action: HEADER_PRIME_BENEFITS_ACTION,
});

export const whatPrimeBannerOnClick = (
  isLoggedInUser: boolean | null,
  trackingCategory: string,
): TrackingData => ({
  label: `prime_header_benefit-banner_click_${WHAT_PRIME_BANNER}_p:${isLoggedInUser}_pag:${trackingCategory}`,
  category: trackingCategory,
  action: HEADER_PRIME_BENEFITS_ACTION,
});
